import { Container, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { CloseIcon } from "../../../../styles/img/svg/CloseIcon";
import { BackIcon } from "../../../../styles/img/svg/BackIcon";
import { ProgressBar } from "../../../_uiComponents/Onboarding/ProgressBar";
import Validator from "../../../../_helpers/validate.schema";
import { UiButton } from "../../../_uiComponents/common/UiButton";
import UiInput from "../../../_uiComponents/UiInput";
import {
  onboardingClearFormResponseData,
  debitCardInitRegisterRequest,
  debitCardPreRegisterRequest,
  onboardingOtpConfirmRequest,
  onboardingOtpResendRequest,
  removeFormDataFeilds,
} from "../../../../_redux/_actions/onboarding.actions";
import {
  commonConstants,
  onboardingConstants,
  responseCodes,
} from "../../../../_redux/_constants";
import { clearCommonErrors } from "../../../../_redux/_actions";
import { InvalidDetailsPopup } from "../popups/InvalidDebitCardNumberPopup";
import { OtpConfirmModal } from "../../auth/views/OtpConfirmModal";
import {
  formatOnboardingAccountNumberInput,
  getFingerPrint,
  getOnboardingAccountNumberPattern,
} from "../../../../_helpers/support.services";
import AccountNoImage from "../../../../styles/img/onboard/account-no.png";

export const AccountNumberForm = (props) => {
  const {
    ownFormData: ownFormData,
    debitCardPreRequestData: debitCardPreRequestData,
    PostRequestData: PostRequestData,
    otpConfirmationData: otpConfirmationData,
    onBoardingOtpTimer: onBoardingOtpTimer,
  } = useSelector((state) => state.onboarding);
  const errorMessage = useSelector((state) => state.errorMessage);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessageCode, setErrorMessageCode] = useState(null);
  const [showHideOtpConfirmation, setShowHideOtpConfirmation] = useState(null);
  const [accountNumberError, setAccountNumberError] = useState(false);
  const [payloadData, setPayloadData] = useState({});

  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const accountType = ownFormData?.accountType;

  const validateSchema = () =>
    yup.object().shape({
      accountNumber: yup
        .string()
        .required(t("This field is required"))
        .matches(
          getOnboardingAccountNumberPattern(accountType),
          t("Please enter a valid account number."),
        ),
    });

  const onValidate = async (values) => {
    return await Validator(values, validateSchema);
  };

  const submit = async (param) => {
    const fingetPrint = await getFingerPrint();

    let payload = {
      locale: i18n.language,
      bankAccountNo: param.accountNumber,
      personalId: ownFormData?.nicNumber
        ? ownFormData.nicNumber
        : ownFormData?.passportNumber,
      personalIdTypeCode: ownFormData?.nicNumber
        ? commonConstants.DOCUMENT_TYPE_NATIONAL_ID
        : commonConstants.DOCUMENT_TYPE_PASSPORT_ID,
      registeredType:ownFormData?.accountType === onboardingConstants.REGISTRATION_OPTION_FIXED_DEPOSITS ? onboardingConstants.ACCOUNT_TYPE_FD : onboardingConstants.ACCOUNT_TYPE_CASA,
      accountType: ownFormData?.accountType,
      isTermAndConAccepted: commonConstants.YES_OPTION_TYPE,
      uid: fingetPrint,
    };

    let restoreData = {
      accountNumber: param.accountNumber,
    };

    payload.restoreData = restoreData;

    setPayloadData(payload);

    dispatch(clearCommonErrors());

    dispatch(debitCardPreRegisterRequest(payload));
  };

  const goBack = () => {
    dispatch(onboardingClearFormResponseData());
    dispatch(clearCommonErrors());
    props?.changeFlowStep(onboardingConstants.SELECT_REGISTRATION_OPTION_STEP);
  };

  useEffect(() => {
    if (errorMessage?.customErrors.length > 0) {
      var status = errorMessage?.customErrors[0];

      if (
        status.statusCode == responseCodes.ONBOARDING_DEBIT_CARD_NUMBER_INVALID
      ) {
        showHideErrorPopups(true);
        setErrorMessageCode(responseCodes.ONBOARDING_DEBIT_CARD_NUMBER_INVALID);
      }

      if (
        status.statusCode == responseCodes.ONBOARDING_DEBIT_CARD_PIN_INVALID
      ) {
        showHideErrorPopups(true);
        setErrorMessageCode(responseCodes.ONBOARDING_DEBIT_CARD_PIN_INVALID);
      }
    }
  }, [errorMessage]);

  const showHideOTP = (param) => {
    setShowHideOtpConfirmation(param);
  };

  const submitInitRequest = () => {
    let initPayload = debitCardPreRequestData;

    dispatch(
      debitCardInitRegisterRequest({ ...initPayload, locale: i18n.language }),
    );
  };

  useEffect(() => {
    if (
      debitCardPreRequestData?.emailOtpEnabled ||
      debitCardPreRequestData?.smsOtpEnabled
    ) {
      submitInitRequest(debitCardPreRequestData);
    }
  }, [debitCardPreRequestData]);

  const showHideErrorPopups = (param) => {
    setShowErrorPopup(param);
  };

  useEffect(() => {
    if (onBoardingOtpTimer) {
      showHideOTP(true);
    }
  }, [onBoardingOtpTimer]);

  const confirmOtp = async (param) => {
    const fingetPrint = await getFingerPrint();

    let payload = { ...param, uid: fingetPrint, locale: i18n.language };

    dispatch(onboardingOtpConfirmRequest(payload));
  };

  const resendOtp = () => {
    let finalPayload = payloadData;

    dispatch(clearCommonErrors());

    dispatch(debitCardPreRegisterRequest(finalPayload));
  };

  useEffect(() => {
    if (
      otpConfirmationData?.isSubProfileActivationProcessCompleted ==
      commonConstants.NO_OPTION_TYPE
    ) {
      showHideOTP(false);
      props?.changeFlowStep(
        onboardingConstants.SELECT_VERIFICATION_OPTION_STEP,
      );
    } else if (
      otpConfirmationData?.isSubProfileActivationProcessCompleted ==
      commonConstants.YES_OPTION_TYPE
    ) {
      showHideOTP(false);
      dispatch(removeFormDataFeilds(["username"]));
      props?.changeFlowStep(onboardingConstants.ONBOARDING_USERNAME_STEP);
    }
  }, [otpConfirmationData]);

  useEffect(() => {
    setPayloadData({});
  }, []);

  return (
    <>
      <div className="df-user-profile df-preset-card df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div
            className="df-user-profile__close-icon"
            onClick={props?.closeBtn}
          >
            <CloseIcon />
          </div>

          <div className="df-user-profile__back-icon df-bc-w-progress">
            <ProgressBar
              noOfActive={2}
              total={
                ownFormData?.registrationType ==
                onboardingConstants.REGISTRATION_OPTION_CASA_ACCOUNT
                  ? 7
                  : 6
              }
            />

            <BackIcon onClick={goBack} />
          </div>

          <div className="df-user-profile__body df-pw-tab">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}>
                <h2 className="df-reset-pw-title text-center">
                  {t("Enter your account number")}
                </h2>

                <img
                  src={AccountNoImage}
                  className="df-reset-pw-img df-onboard-side-img"
                />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-right df-pl-2"
              >
                <div className="df-onboard-nic-wr">
                  <Form
                    initialValues={{
                      accountNumber: ownFormData?.accountNumber,
                    }}
                    onSubmit={submit}
                    validate={onValidate}
                    render={({
                      handleSubmit,
                      values,
                      submitting,
                      error,
                      hasValidationErrors,
                      form,
                    }) => {
                      const isFormValid = !hasValidationErrors;

                      const { dirty } = form.getState();

                      return (
                        <>
                          <div className="df-onboard-inputs">
                            <UiInput
                              name="accountNumber"
                              id="accountNumber"
                              label={t("Account Number *")}
                              type="text"
                              clearable={true}
                              maxLength={
                                onboardingConstants.ONBOARDING_ACCOUNT_NUMBER_MAX_LENGTH
                              }
                              minLength={8}
                              form={form}
                              autoComplete="off"
                              value={values.accountNumber}
                              inputonChange={(e) => {
                                const { value: accountNo } =
                                  formatOnboardingAccountNumberInput(
                                    e.target.value,
                                    accountType,
                                  );
                                form.change("accountNumber", accountNo);
                              }}
                              error={accountNumberError}
                              helperText={
                                accountNumberError ? accountNumberError : null
                              }
                            />
                          </div>

                          <UiButton
                            onClick={handleSubmit}
                            className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn"
                            name={t("Next")}
                            disabled={!isFormValid}
                          />
                        </>
                      );
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <InvalidDetailsPopup
        isOpen={showErrorPopup}
        statusCode={errorMessageCode}
        closeModal={showHideErrorPopups}
      />

      <OtpConfirmModal
        show={showHideOtpConfirmation}
        userDetails={{
          phone1: PostRequestData?.phoneNo ?? PostRequestData?.customer?.phone1,
          email: PostRequestData?.email ?? PostRequestData?.customer?.email,
        }}
        otpConfirmRequest={confirmOtp}
        otpResendRequest={resendOtp}
        closeModal={() => {
          showHideOTP(false);
        }}
        countDownTimer={onBoardingOtpTimer}
      />
    </>
  );
};
